import {addDays, startOfDay} from 'date-fns';
import {FormControl} from 'platform/components';

import {useEffect} from 'react';
import {UseFormReturn, useWatch} from 'react-hook-form';

import {GetTireSetDestinationBranchApiResponse} from '@dms/api/core';

import {parseDate} from 'shared/web';

import {RequestTireSetFormDefinition} from '../types/RequestTireSetFormDefinition';

export interface PrefillFormDataProps {
  control: FormControl<RequestTireSetFormDefinition>;
  formApi: UseFormReturn<RequestTireSetFormDefinition>;
  tireSetDestinationBranches: GetTireSetDestinationBranchApiResponse | undefined;
}

export function PrefillFormData(props: PrefillFormDataProps) {
  const selectedBranchId = useWatch({
    control: props.control,
    name: 'requestBranchId',
  });

  // Pre-fill destinationBranchId
  useEffect(() => {
    if (
      props.tireSetDestinationBranches &&
      props.tireSetDestinationBranches.length > 0 &&
      !selectedBranchId &&
      props.formApi
    ) {
      const defaultBranch = props.tireSetDestinationBranches.find((branch) => branch.isDefault);
      if (defaultBranch) {
        props.formApi.setValue('requestBranchId', defaultBranch.branchId);
      }
    }
  }, [props.tireSetDestinationBranches, selectedBranchId, props.formApi]);

  // Pre-fill neededAtDate and calculate disabled dates based on selected branch
  useEffect(() => {
    const selectedBranch = props.tireSetDestinationBranches?.find(
      (branch) => branch.branchId === selectedBranchId
    );

    if (selectedBranch && props.formApi) {
      const currentNeededAtDate = props.formApi.getValues('neededAtDate');
      const minimumDate = addDays(startOfDay(new Date()), selectedBranch.transitTimeDays);

      // Pre-fill neededAtDate if not already set
      if (!currentNeededAtDate) {
        props.formApi.setValue('neededAtDate', minimumDate);
      } else {
        // Check if current date is now disabled (before minimum allowed date)
        const currentDateStart = startOfDay(parseDate(currentNeededAtDate));
        const minimumDateStart = startOfDay(minimumDate);

        if (currentDateStart < minimumDateStart) {
          // Current date is disabled, set to minimum allowed date
          props.formApi.setValue('neededAtDate', minimumDate);
        }
      }
    }
  }, [selectedBranchId, props.tireSetDestinationBranches, props.formApi]);

  return null;
}
